import { render, staticRenderFns } from "./AllMessages.vue?vue&type=template&id=19692e62&"
import script from "./AllMessages.vue?vue&type=script&lang=js&"
export * from "./AllMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports